import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";

import LoginScreen from "./App/views/templates/login.js";
import Activation from "./App/Activation/index.js";
import DashboardScreen from "./App/views/templates/dashboard.js";
import ForgotScreen from "./App/views/templates/dashboard/user/forgot.js";
import ResetScreen from "./App/views/templates/dashboard/user/reset.js";
import browserSupportScreen from "./App/views/templates/dashboard/page/browserSupport.js";
import browser from "browser-detect";
import "./App.css";

/* single page to AssetVault mobile app */
import IncomingMessageList from "home/helper/component/IncomingMessage/IncomingMessageList";
import AssetRegistrationScreen from "views/templates/dashboard/asset/form/registration";
import AssetDetailScreen from "views/templates/dashboard/asset/form/detail";
import JobList from "topmenu/job/helper/component/JobList";
import UserSettingsScreen from "views/templates/dashboard/user/settings";
import MaintenancByAssetScreen from "views/templates/dashboard/maintenance/maintenance_by_asset.js";
import JobStockCheckScreen from "views/templates/dashboard/job/job_stock_check.js";
import JobStockCheckDetailScreen from "views/templates/dashboard/job/job_stock_detail.js";
import Confirm from "component/Confirm";

class App extends Component {
  setConfirm = node => {
    window._confirm = node;
  };

  componentWillUnmount() {
    window._confirm = null;
  }

  render() {
    let browser_info = browser();

    return (
      <div>
        {browser_info.name === "ie" ? (
          <Router>
            <div>
              <Switch>
                <Route
                  path="/"
                  name="browserSupport"
                  component={browserSupportScreen}
                />
              </Switch>
            </div>
          </Router>
        ) : (
          <Router>
            <div>
              {window.ReactNativeWebView && (
                <ToastContainer
                  position="top-center"
                  type="default"
                  autoClose={5000}
                  hideProgressBar={true}
                  newestOnTop={false}
                  closeOnClick
                  pauseOnHover
                />
              )}
              <Switch>
                {window.ReactNativeWebView && [
                  <Route
                    exact
                    path="/single-page/incoming-message"
                    name="Incoming Message"
                    component={IncomingMessageList}
                  />,
                  <Route
                    exact
                    path="/single-page/asset-registration"
                    name="Asset Registration"
                    component={AssetRegistrationScreen}
                  />,
                  <Route
                    exact
                    path="/single-page/master-asset-details-:Alias"
                    name="Asset Detail"
                    component={AssetDetailScreen}
                  />,
                  <Route
                    exact
                    path="/single-page/maintenance-list/:AssetAlias/:AssetName/:Owner"
                    name="MaintenancByAsset"
                    component={MaintenancByAssetScreen}
                  />,
                  <Route
                    exact
                    path="/single-page/job"
                    name="Job"
                    component={JobList}
                  />,
                  <Route
                    exact
                    path="/single-page/job/job-stock-check/:SiteAlias/:SiteName"
                    name="JobStockCheck"
                    component={JobStockCheckScreen}
                  />,
                  <Route
                    exact
                    path="/single-page/job/job-stock-check-detail/:StockAlias/:SiteName"
                    name="JobStockCheckDetail"
                    component={JobStockCheckDetailScreen}
                  />,
                  <Route
                    exact
                    path="/single-page/user/settings"
                    name="User-Settings"
                    component={UserSettingsScreen}
                  />,
                  <Route
                    exact
                    path="/single-page/admin/job-stock-check"
                    name="JobStockCheck"
                    component={JobStockCheckScreen}
                  />
                ]}
                <Route
                  exact
                  path="/login"
                  name="Login"
                  component={LoginScreen}
                />
                <Route
                  exact
                  path="/forgot"
                  name="Forgot"
                  component={ForgotScreen}
                />
                <Route
                  exact
                  path="/reset/:token"
                  name="Recovery"
                  component={ResetScreen}
                />
                <Route
                  exact
                  path="/register/:token"
                  name="Activation"
                  component={Activation}
                />
                <Route path="/" name="Dashboard" component={DashboardScreen} />
              </Switch>
            </div>
          </Router>
        )}
        <Confirm onRef={this.setConfirm} />
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js